<template>
    <div class="radio">
        <input @input="(event) => $emit('update:checked', event.target.checked)" class="checkbox-input" type="radio"
               :name="name" :slug="slug" :id="fieldId" :checked="checked"/>
        <label :for="fieldId" v-html="label"></label>
    </div>
</template>
<script>
export default {
    props: {
        name: String,
        label: String,
        fieldId: {
            type: String,
            required: true,
        },
        slug: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
        },
    },
    computed: {
        storeResetFilterState() {
            return this.$store.state.resetAllFilters;
        }
    },
    watch: {
        storeResetFilterState(value) {
            // watch 'resetAllFilters' from store. If this is true then all filters should be reset
            this.setFalse();
        }
    },
    methods: {
        setFalse() {
            this.$emit('reset:all', false);
        }
    }
};
</script>
